import { isPlatformBrowser } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class FontsService {
  constructor(@Inject(PLATFORM_ID) public platformId) {}

  public changeFont(selectedFont: string): void {
    if (isPlatformBrowser(this.platformId) && selectedFont) {
      const gaScript = document.createElement("link");
      gaScript.setAttribute(
        "href",
        `https://fonts.googleapis.com/css2?family=${selectedFont}&display=swap`
      );
      gaScript.setAttribute("rel", `stylesheet`);
      document.documentElement.firstChild.appendChild(gaScript);
      document.body.style.setProperty(
        "--font-family-text",
        selectedFont.replace(/\+/g, " ")
      );
    }
  }

  public AddFont(selectedFont: string): void {
    if (isPlatformBrowser(this.platformId) && selectedFont) {
      const gaScript = document.createElement("link");
      gaScript.setAttribute(
        "href",
        `https://fonts.googleapis.com/css2?family=${selectedFont}&display=swap`
      );
      gaScript.setAttribute("rel", `stylesheet`);
      document.documentElement.firstChild.appendChild(gaScript);
    }
  }
}
